import { NgClass } from '@angular/common'
import { Component, inject, Input, OnInit } from '@angular/core'
import { StudyService } from '@nx-superprep/backend/firebase'
import { ResponsiveComponent } from '@nx-superprep/shared'
import { log } from '@nx-superprep/utils'
import { BsModalRef } from 'ngx-bootstrap/modal'

@Component({
  selector: 'study-lesson-pause',
  standalone: true,
  templateUrl: './lesson-pause.component.html',
  styleUrls: ['./lesson-pause.component.scss'],
  imports: [NgClass],
})
export class LessonPauseComponent extends ResponsiveComponent implements OnInit {
  @Input()
  get moduleId() { return this._moduleId }
  set moduleId(value) { this._moduleId = value ?? undefined }

  readonly bsModalRef = inject(BsModalRef)
  readonly studyService = inject(StudyService)

  constructor(
  ) {
    super()
    this.rootClassName = 'pause-root-class-name'
  }

  onAction(name: string) {
    log.debug(name)
    switch (name) {
      case 'settings': { this.openSettings(); break }
      case 'continue': { this.continue(); break }
      case 'quit':
      default: { this.quit(); break }
    }
    this.bsModalRef?.onHide?.emit()
    this.bsModalRef?.hide()
  }

  quit() {
    this.navigateTo([this.studyService.activeLesson ? '/' : '/library'])
  }

  continue() {
    this.navigateTo([this.studyService.activeLesson ? '/study' : '/quiz', this.moduleId??''])
  }

  openSettings() {
    this.navigateTo(['/settings', this.moduleId??''])
  }

  private _moduleId: string | undefined = undefined

  override ngOnInit(): void {
    super.ngOnInit()
    if (!this.isWeb) { this.orientationService.lockOrientation('portrait-primary') }
  }

  private navigateTo(path?: string[]) {
    return path ? this.router.navigate(path, { replaceUrl: true, skipLocationChange: true }) : Promise.resolve(true)
  }

}
